import React, {useState} from 'react'
import css from '../LoginV2Layout.module.scss'
import LoginV2Layout from '../LoginV2Layout'
import PasswordRecoveryForm from './containers/PasswordRecoveryForm'
import LoginForm from './containers/LoginForm'
import GoogleSignInButton from './containers/GoogleSignInButton'
import {isInternalUser} from '../../../utils/cookies'

const LoginV2 = ({logo, supportEmail, errorMessage}) => {
  const [recoverPasswordForm, setRecoverPasswordForm] = useState(false)
  const [showPasswordForm, setShowPasswordForm] = useState(false)
  const showGoogleSignIn = isInternalUser() && !showPasswordForm && !recoverPasswordForm

  return (
    <LoginV2Layout logo={logo}>
      <div className={css.formContainer}>
        {!recoverPasswordForm ?
          <div className={css.welcomeSection}>
            <h1 className={css.welcomeTitle}>Welcome back!</h1>
            <p className={css.welcomeSubtitle}>Your next opportunity awaits.</p>
          </div>
        :
          <div className={css.welcomeSection}>
            <h1 className={css.welcomeTitle}>Password reset</h1>
            <p className={css.welcomeSubtitle}>Enter your email address or username and we'll send you instructions to reset your password</p>
          </div>
        }
        <div className={css.loginForm}>
          {recoverPasswordForm ? (
            <PasswordRecoveryForm/>
          ) : showGoogleSignIn ? (
            <>
              <GoogleSignInButton />
              {errorMessage && (
                <p className="error">{errorMessage}</p>
              )}
            </>
          ) : (
            <LoginForm supportEmail={supportEmail}/>
          )}
        </div>
      </div>
      <div>
        {recoverPasswordForm ? (
          <p onClick={() => setRecoverPasswordForm(false)}
             className={css.passwordRecovery}>
            Back to login
          </p>
        ) : showGoogleSignIn ? (
          <p onClick={() => setShowPasswordForm(true)}
             className={css.passwordRecovery}>
            Use username and password instead
          </p>
        ) : (
          <p onClick={() => setRecoverPasswordForm(true)}
             className={css.passwordRecovery}>
            Forgot your password?
          </p>
        )}
      </div>
    </LoginV2Layout>
  )
}

export default LoginV2
